module.exports = __webpack_public_path__ + "img/help-circle-white.b6e81691.svg";